import React from 'react'
import {
  Root,
  Portal,
  Overlay,
  Content,
  Title,
  Close
} from '@radix-ui/react-dialog'
import PropTypes from 'prop-types'
import styles from './Popup.module.scss'

const Popup = React.memo(
  ({ show, onOpenChange, title, children, className }) => {
    // Force show to be a boolean
    const isOpen = !!show

    return (
      <Root open={isOpen} onOpenChange={onOpenChange}>
        <Portal>
          <Overlay className={styles.overlay} />
          <Content
            className={`${styles.content} ${className || ''}`}
            aria-labelledby={title ? 'popup-title' : undefined}
            role='dialog'
          >
            {title && (
              <Title id='popup-title' className={styles.title}>
                {title}
              </Title>
            )}
            <div className={styles.body}>{children}</div>
            <Close asChild>
              <button
                className={styles.closeButton}
                aria-label='Close'
                tabIndex={0}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  x='0px'
                  y='0px'
                  width='16'
                  height='16'
                  viewBox='0 0 26 26'
                  aria-hidden='true'
                >
                  <path d='M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z'></path>
                </svg>
              </button>
            </Close>
          </Content>
        </Portal>
      </Root>
    )
  }
)

// Define PropTypes for the component
Popup.propTypes = {
  show: PropTypes.bool,
  onOpenChange: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
}

// Define defaultProps for the component
Popup.defaultProps = {
  show: false,
  onOpenChange: () => {},
  title: '',
  children: null,
  className: ''
}

export default Popup
